angular.module('zc.projects')

.controller 'ImageBrowserController', ["$scope", "$modalInstance", "images", "currentImageUrl", "Image", ($scope, $modalInstance, images, currentImageUrl, Image) ->
  $scope.images = images
  $scope.Image = Image
  $scope.selected = {}

  for img in $scope.images
    if img.image_url == currentImageUrl
      $scope.selected.img = img

  $scope.selectImage = (img) ->
    $scope.selected.img = img

  $scope.markAsUnselectable = (img) ->
    $scope.Image.markAsUnselectable(img).then (res) ->
      $scope.images = res

  $scope.ok = () ->
    $modalInstance.close($scope.selected.img)

  $scope.cancel = () ->
    $modalInstance.dismiss('cancel')
]



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/controllers/images/image_browser_controller.js.coffee